import { PropsWithChildren, useCallback, useEffect, useState } from "react";
import typedLocalStorage, { LoginChallengeData } from "../typedLocalStorage";
import { LocalStorageContext, State } from "./state";

type LocalStorageInitProps = {
  loginChallenge: string;
};
const LocalStorageInit: React.FC<PropsWithChildren<LocalStorageInitProps>> = (
  props,
) => {
  const { children, loginChallenge } = props;
  const [value, setValue] = useState<State>({
    tag: "uninit",
    data: {},
  });

  const updateItem = useCallback(
    (value: Partial<LoginChallengeData>) => {
      const currentChallengeData = typedLocalStorage.setItem(
        "login_challenge",
        loginChallenge,
        value,
      );

      setValue((prevValue) => {
        if (prevValue.tag === "ready") {
          prevValue.data.currentChallengeData = currentChallengeData;
        }
        return prevValue;
      });
    },
    [loginChallenge],
  );

  useEffect(() => {
    const currentChallengeData = typedLocalStorage.getItem(
      "login_challenge",
      loginChallenge,
    );

    setValue({
      tag: "ready",
      data: {
        currentChallengeData,
        updateItem,
      },
    });
  }, [loginChallenge, updateItem]);

  return (
    <LocalStorageContext.Provider value={value}>
      {children}
    </LocalStorageContext.Provider>
  );
};

export default LocalStorageInit;
